/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getMutes.defs.js'
export { main as default } from './getMutes.defs.js'
